module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-31.2fcdd2d5.png";